
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airports",
      function () {
        return require("private-next-pages/airports.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airports"])
      });
    }
  